// Copyright 2024, Imprivata, Inc.  All rights reserved.

import type { InitOptions } from 'i18next';
import { resources, defaultNS, ns } from './resources';

const baseI18nextOptions: InitOptions = {
  // debug: true, // uncomment to debug
  defaultNS,
  resources,
  ns,
  lng: undefined,
  supportedLngs: [
    'en',
    'es',
    'ar',
    'fr',
    'de',
    'it',
    'pt',
    'nl',
    'sv',
    'fi',
    'da',
    'cs',
    'no',
  ],
  fallbackLng: 'en',
  nonExplicitSupportedLngs: true,
  returnEmptyString: false,

  detection: {
    order: ['querystring', 'navigator'],
    lookupQuerystring: 'lng',
    caches: [],
  },

  react: {
    useSuspense: false,
  },
};

const i18nextOptions = (options = {}): InitOptions => {
  return {
    ...baseI18nextOptions,
    ...options,
  };
};

export default i18nextOptions;
